import React, { FC, ReactNode } from 'react'

import { colors } from '@smarty-nx/ds'
import cn from 'classnames'

import classes from './bubble-hero.module.scss'
import LeftCircles from '../../static/images/leftCircles.svg'
import RightCircles from '../../static/images/rightCircles.svg'
import { FullWidthContainer, SiteContainer } from '../shared'

interface BubbleHeroProps {
  children?: ReactNode
  background?: string
}

export const BubbleHero: FC<BubbleHeroProps> = ({ children, background }) => (
  <FullWidthContainer background={background || colors['UI/DarkerGrey']}>
    <div className={classes.bubbleBackground}>
      <img
        className={classes.bubbleImgLeft}
        src={LeftCircles}
        alt=""
        aria-hidden
      />
      <img
        className={classes.bubbleImgRight}
        src={RightCircles}
        alt=""
        aria-hidden
      />
    </div>
    <SiteContainer className={classes.bubbleContent}>{children}</SiteContainer>
  </FullWidthContainer>
)

interface BubbleContentWrapperProps {
  children?: ReactNode
  isRaf?: boolean
  smallText?: boolean
  className?: string
}

export const BubbleContentWrapper: FC<BubbleContentWrapperProps> = ({
  children,
  isRaf,
  smallText,
  className,
}) => (
  <div
    className={cn(
      classes.bubbleContentWrapper,
      isRaf && classes.bubbleContentWrapperRaf,
      smallText && classes.bubbleContentWrapperSmallText,
      className
    )}
  >
    {children}
  </div>
)
